import { render, staticRenderFns } from "./TruckIcon.vue?vue&type=template&id=d20ce144&scoped=true&"
import script from "./TruckIcon.vue?vue&type=script&lang=js&"
export * from "./TruckIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20ce144",
  null
  
)

export default component.exports